import { render, staticRenderFns } from "./classNotice.vue?vue&type=template&id=d8729b56&scoped=true"
import script from "./classNotice.vue?vue&type=script&lang=js"
export * from "./classNotice.vue?vue&type=script&lang=js"
import style0 from "./classNotice.vue?vue&type=style&index=0&id=d8729b56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8729b56",
  null
  
)

export default component.exports